import React, { useState, useEffect } from 'react';
import { CheckCircle2, XCircle, Info } from 'lucide-react';

const ToastTypes = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info'
};

const ToastMessage = ({ message, type = ToastTypes.SUCCESS, duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      onClose && onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!isVisible) return null;

  const typeStyles = {
    [ToastTypes.SUCCESS]: {
      bg: 'bg-green-50',
      border: 'border-green-200',
      text: 'text-green-700',
      icon: <CheckCircle2 className="text-green-500" size={24} />
    },
    [ToastTypes.ERROR]: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      text: 'text-red-700',
      icon: <XCircle className="text-red-500" size={24} />
    },
    [ToastTypes.INFO]: {
      bg: 'bg-blue-50',
      border: 'border-blue-200',
      text: 'text-blue-700',
      icon: <Info className="text-blue-500" size={24} />
    }
  };

  const { bg, border, text, icon } = typeStyles[type];

  return (
    <div 
      className={`fixed top-4 right-4 z-50 flex items-center p-4 rounded-lg shadow-lg ${bg} ${border} ${text}`}
    >
      <div className="mr-3">{icon}</div>
      <div className="flex-1">
        <p className="font-medium">{message}</p>
      </div>
      <button 
        onClick={() => setIsVisible(false)} 
        className="ml-4 focus:outline-none"
      >
        <XCircle className="text-gray-400 hover:text-gray-600" size={20} />
      </button>
    </div>
  );
};

export { ToastMessage, ToastTypes };